import { getField, updateField } from "vuex-map-fields";
import API from "../../../api";
import moment from "moment";
// import axios from "axios";
import "moment/locale/pt-br";

export const state = () => ({
  // filtros
  searchDsPalavrasChave: null,
  searchDsTituloDocumento: null,
  searchType: null,
  typeField: [
    { label: "Arquivo", code: true },
    { label: "Link", code: false },
  ],
  // table
  biblioteca: [],
  loadingTable: false,
  // paginacao
  pagination: {
    size: 10,
    totalPages: 0,
    totalElements: 0,
    offset: 0,
  },
  totalItems: 0,
  totalPages: 0,
  itemsPerPage: 10,
  currentPage: 1,
});

export const getters = {
  getField,
  formatDate: () => (date) => formatDate(date),
};

function formatDate(date) {
  if (!date) return "";
  return moment(date).format("DD/MM/YYYY HH:mm");
}

function formatLink(link) {
  if (link.includes("http://") || link.includes("https://")) {
    return link;
  } else {
    return "https://" + link;
  }
}

function mountSearchPayload(state) {
  const config = {
    params: new URLSearchParams(),
  };

  config.params.append("size", state.pagination.size);
  config.params.append("page", state.currentPage - 1);

  if (state.searchDsPalavrasChave) {
    config.params.append("dsPalavrasChave", state.searchDsPalavrasChave);
  }

  if (state.searchDsTituloDocumento) {
    config.params.append("dsTituloDocumento", state.searchDsTituloDocumento);
  }

  if (state.searchType == false || state.searchType == true) {
    config.params.append("isEditing", state.searchType);
  }

  return config;
}

export const actions = {
  async get({ dispatch, state, commit, rootState }, payload) {
    commit("updateField", { path: "pagination.offset", value: 0 });
    // commit("updateField", { path: "loadingTable", value: true });
    commit("updateField", { path: "biblioteca", value: [] });
    commit("updateField", { path: "currentPage", value: 1 });
    // commit("updateField", { path: "totalPages", value: 0 });

    const result = await API.axios.get(
      "/bff/api/v1/library",
      mountSearchPayload(state)
    );
    if (!result) {
      commit("updateField", { path: "loadingTable", value: false });
      return undefined;
    } else if (result.status >= 400 && result.status <= 600) {
      commit("updateField", { path: "loadingTable", value: false });
      return result;
    } else if (result.data?.totalElements > 0) {
      commit("updateField", { path: "currentPage", value: 1 });
    } else {
      commit("updateField", { path: "currentPage", value: 0 });
      commit("updateField", { path: "pagination.totalPages", value: 0 });
      commit("updateField", { path: "pagination.offset", value: 0 });
    }

    // total number of items
    if (result.data.totalElements) {
      commit("updateField", {
        path: "pagination.totalElements",
        value: result.data.totalElements,
      });
      commit("updateField", {
        path: "pagination.totalPages",
        value: result.data.totalPages,
      });
    }
    if (result.data.content) {
      commit("updateField", { path: "biblioteca", value: result.data.content });
    }

    commit("updateField", { path: "loadingTable", value: false });
    return state.biblioteca;
  },

  async getPage({ state, commit, rootState }, payload) {
    commit("updateField", { path: "loadingTable", value: true });
    const result = await API.axios.get(
      "/bff/api/v1/library",
      mountSearchPayload(state)
    );

    if (!result) {
      commit("updateField", { path: "loadingTable", value: false });
      return undefined;
    } else if (result.status >= 400 && result.status <= 600) {
      commit("updateField", { path: "loadingTable", value: false });
      return result;
    } else if (result.data?.content) {
      // update table items
      commit("updateField", { path: "biblioteca", value: result.data.content });
      commit("updateField", {
        path: "pagination.offset",
        value: result.data.pageable.offset,
      });
    }
    commit("updateField", { path: "loadingTable", value: false });
    return result;
  },

  async delete({ dispatch, state }, payload) {
    const response = await API.axios.delete(
      `/bff/api/v1/library/${payload.idLibrary}`,
      payload
    );
    return response;
  },

  async post({ dispatch, state }, payload) {
    const response = await API.axios.post("/bff/api/v1/library", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  },

  async put({ dispatch, state }, payload) {
    const response = await API.axios.put(
      `/bff/api/v1/library/${payload.idLibrary}`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  },

  async downloadFile({ commit }, payload) {
    let response = await API.axios.get(
      `/bff/api/v1/static/library/${payload.idLibrary}/${payload.fileName}`,
      {
        responseType: "blob",
      }
    );
    if (response.status === 200) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", payload.fileName);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      return {
        status: response.status,
        data: { message: "Arquivo baixado com sucesso!" },
      };
    } else {
      return { status: response.status, data: "Erro ao baixar o arquivo!" };
    }
  },

  async getTitle({ commit }, payload) {
    const config = {
      params: new URLSearchParams(),
    };

    config.params.append("url", formatLink(payload));

    const response = await API.axios.get(
      `/bff/api/v1/page-details/title`,
      config
    );

    if (response.status === 200) {
      return response.data;
    }

    return null;
  },
};

export const mutations = {
  updateField,
  setItemsPerPage(state, payload) {
    state.pagination.size = payload;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
